import { ref, computed, onMounted, onUnmounted } from 'vue';
import { numberingClient } from '@/composables/useEspoNumbering';
import useVaultDirectory from '@/composables/useVaultDirectory';
import { expandCardLocations, hasCurrentLocations, matchingVaults } from '@/services/vaults.mjs';

const locations = ref(null);
const context = ref(null);
const locationError = ref('');
const loading = ref(true);
let pending;
let timer;
let subscribers = 0;
async function refreshLocations() {
  if (pending) return pending;
  loading.value = true;
  pending = numberingClient.allUnits().then(result => {
    const next = expandCardLocations(result.items);
    if (!hasCurrentLocations(result.context)) throw new Error('numbering_not_current');
    if (subscribers) { locations.value = next; context.value = result.context; locationError.value = ''; }
  }).catch(() => {
    if (subscribers) { locations.value = null; context.value = null; locationError.value = 'Current card locations are temporarily unavailable.'; }
  }).finally(() => { if (subscribers) loading.value = false; pending = null; });
  return pending;
}
export default function useCollectionVaults() {
  const directory = useVaultDirectory();
  onMounted(() => { subscribers += 1; if (subscribers === 1) { refreshLocations(); timer = setInterval(refreshLocations, 60000); } });
  onUnmounted(() => { subscribers -= 1; if (!subscribers) clearInterval(timer); });
  const ready = computed(() => directory.records.value !== null && locations.value !== null);
  const matches = computed(() => {
    if (!ready.value) return {};
    return Object.fromEntries(Object.entries(locations.value).map(([serial, location]) => [serial, matchingVaults(location, directory.records.value)]).filter(([, vaults]) => vaults.length));
  });
  return {
    matches, ready, context, locations, records: directory.records,
    loading: computed(() => loading.value || directory.loading.value),
    error: computed(() => directory.error.value || locationError.value),
    refresh: () => Promise.all([refreshLocations(), directory.refresh()]),
  };
}
